import React, { useContext, useEffect, useState } from "react";
import { Tabs } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";

import Layout from "../layout/Layout";
import CompanyLeft from "../components/company-search/CompanyLeft";
import CompanyContent from "../components/company-search/CompanyContent";
import CompanyNavigation from "../components/company-search/CompanyNavigation";
import TrialModal from "../common/TrialModal";
import {
  emptyErrorObj,
  getCompanyList,
  saveAdvancedSelectedFilters,
  savePaginationValues,
  selectedRow,
} from "../actionCreator/companyListingActionCreater";
import "../assets/css/dynemic-page.css";
import ExecutiveNavigation from "../components/executive-search/ExecutiveNavigation";
import ExecutiveLeft from "../components/executive-search/ExecutiveLeft";
import ExecutiveContent from "../components/executive-search/ExecutiveContent";
import LeadContent from "../components/lead-search/LeadContent";
import LeadNavigation, {
  emptyLeadFilters,
} from "../components/lead-search/LeadNavigation";
import LeadLeft from "../components/lead-search/LeadLeft";
import { INDUSTRY_LIST_ERROR } from "../actionType/companyListingType";
import { subscriptionContentInfo } from "../config";
import subscribepopupImg from "../assets/images/subscribe-now-prompt-img.jpg";
import { resetExecutiveFilters } from "./ExecutiveSearch";
import { AuthContext } from "../context/AuthContext";

export const resetCompanyFilters = (dispatch) => {
  dispatch(
    saveAdvancedSelectedFilters({
      selectedCountry: [],
      selectedState: [],
      selectedCity: [],
      selectedIndustry: [],
      selectedCompanytype: [],
      selectedEmployeecount: [],
      selectedRevenuerange: [],
      selectedSavedSearch: [],
      selectedCompanyTag: [],
      quickSelectionRange: null,
    })
  );
  dispatch(getCompanyList({}, { start: 0, end: 10 }));
  dispatch(savePaginationValues({ start: 0, end: 10 }));
  dispatch(selectedRow([]));
};

const CompanySearch = ({ tab }) => {
  const location = useLocation();
  const { isAuthenticated } = useContext(AuthContext);
  const [activeTab, setActiveTab] = useState(tab);
  const navigate = useNavigate();
  const [isApiFailed, setIsApiFailed] = useState({
    isFailed: false,
    errObj: {},
  });
  const errObj = useSelector((state) => state.companyListingReducer.errObj);
  const dispatch = useDispatch();
  const { isCompanyView, isLeadView, isExecutiveView } =
    useContext(AuthContext);

  useEffect(() => {
    if (!isCompanyView && isAuthenticated) {
      navigate("/dashboard-view");
    }
  }, [isCompanyView, navigate, isAuthenticated]);

  useEffect(() => {
    setActiveTab(tab);
  }, [location, tab]);

  useEffect(() => {
    if (activeTab === "1") {
      resetCompanyFilters(dispatch);
    }
    if (activeTab === "2") {
      resetExecutiveFilters(dispatch);
    }
    if (activeTab === "3") {
      emptyLeadFilters(dispatch);
    }
  }, [activeTab, dispatch]);

  useEffect(() => {
    setIsApiFailed({ isFailed: !!Object.keys(errObj).length, errObj: errObj });
  }, [errObj]);

  const onChange = (key) => {
    setActiveTab(key);
    dispatch(selectedRow([]));
  };
  const selectedItem = useSelector((state) => state.HeaderReducer.selectedItem);
  const topSearchClick = useSelector(
    (state) => state.HeaderReducer.topSearchClick
  );

  useEffect(() => {
    if (location.pathname === "/search-company" && selectedItem === "Company") {
      setActiveTab("1");
    } else if (
      location.pathname === "/search-company" &&
      selectedItem === "Executive"
    ) {
      setActiveTab("2");
    }
  }, [topSearchClick, selectedItem, location.pathname]);

  const redirectToSignup = () => {
    navigate("/signup");
  };

  let items = [];
  if (isAuthenticated) {
    items = [
      {
        key: "1",
        isVisible: isCompanyView,
        label: (
          <span>
            <i className="fa tab-img la la-building"></i>Companies
          </span>
        ),
        children: (
          <div>
            <CompanyNavigation />
            <div id="wrapper">
              <div className="leftmenu">
                <CompanyLeft />
              </div>
              <div className="contentbody">
                <CompanyContent />
              </div>
            </div>
          </div>
        ),
      },
      {
        key: "2",
        isVisible: isExecutiveView,
        label: (
          <span>
            <i className="fa tab-img la la-user-tie"></i>Executive
          </span>
        ),
        children: (
          <div>
            <ExecutiveNavigation />
            <div id="wrapper">
              <div className="leftmenu">
                <ExecutiveLeft />
              </div>
              <div className="contentbody shadow">
                <ExecutiveContent />
              </div>
            </div>
          </div>
        ),
      },

      {
        key: "3",
        isVisible: isLeadView,
        label: (
          <span>
            <i className="fa tab-img las la-user-friends"></i>Leads
          </span>
        ),
        children: (
          <div>
            <LeadNavigation />
            <div id="wrapper">
              <div className="leftmenu">
                <LeadLeft />
              </div>
              <LeadContent />
            </div>
          </div>
        ),
      },
    ];
  } else {
    items = [
      {
        key: "1",
        isVisible: true,
        label: (
          <span>
            <i className="fa tab-img la la-building"></i>Companies
          </span>
        ),
        children: (
          <div>
            <CompanyNavigation />
            <div id="wrapper">
              <div className="leftmenu">
                <CompanyLeft />
              </div>
              <div className="contentbody shadow">
                <CompanyContent />
              </div>
            </div>
          </div>
        ),
      },
      {
        key: "2",
        isVisible: true,
        label: (
          <span>
            <i className="fa tab-img la la-user-tie"></i>Executive
          </span>
        ),
        children: (
          <div>
            <ExecutiveNavigation />
            <div id="wrapper">
              <div className="leftmenu">
                <ExecutiveLeft />
              </div>
              <div className="contentbody shadow">
                <ExecutiveContent />
              </div>
            </div>
          </div>
        ),
      },
      {
        key: "3",
        isVisible: true,
        label: (
          <span>
            <i className="fa tab-img las la-user-friends"></i>Leads
          </span>
        ),
        children: (
          <div>
            <TrialModal
              openModal={true}
              closeModal={redirectToSignup}
              redirectToSignup={redirectToSignup}
              redirect={true}
              buttonText={subscriptionContentInfo.btntext}
              modalBody={
                <div id="small-dialog2">
                  <div align="center">
                    <img src={subscribepopupImg} alt="" />
                  </div>
                  <p style={{ color: "#0000FF" }}>
                    {subscriptionContentInfo.content}
                  </p>
                </div>
              }
              modalWidth="400px"
            />
          </div>
        ),
      },
    ];
  }

  const closeModal = () => {
    dispatch(emptyErrorObj());
  };

  return (
    <>
      <Layout>
        <div id="tabscompany">
          <h3 className="pagetitle">
            {parseInt(activeTab) === 1
              ? "Search Companies"
              : parseInt(activeTab) === 2
                ? "Search Executive"
                : "Search Leads"}
          </h3>
          <Tabs
            activeKey={activeTab}
            items={items?.filter((d) => d?.isVisible)}
            onChange={onChange}
            type="card"
          />

          {isApiFailed.errObj[INDUSTRY_LIST_ERROR] ? (
            <TrialModal
              openModal={!!isApiFailed.errObj[INDUSTRY_LIST_ERROR]}
              closeModal={closeModal}
              buttonText="OK"
              modalBody={
                <div id="small-dialog2">
                  {isApiFailed.errObj[INDUSTRY_LIST_ERROR] &&
                  isApiFailed.errObj[INDUSTRY_LIST_ERROR].message
                    ? isApiFailed.errObj[INDUSTRY_LIST_ERROR].message
                    : "Please call System support. You application having some issue."}
                </div>
              }
              modalWidth="400px"
            />
          ) : (
            ""
          )}
        </div>
      </Layout>
    </>
  );
};
export default CompanySearch;
